import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useTranslation } from "next-i18next";
import { TrendingUp } from "lucide-react";

interface PairsTradingApproachModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function PairsTradingApproachModal({
  isOpen,
  onOpenChange,
}: PairsTradingApproachModalProps) {
  const { t } = useTranslation("marketplace-page");

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md  shadow-2xl ">
        <DialogHeader className="space-y-4">
          <DialogTitle className="text-2xl font-bold text-center tracking-tight text-foreground">
            {t("Directional Pairs Trading")}
          </DialogTitle>
          <DialogDescription className="text-base text-muted-foreground leading-relaxed text-center px-2">
            <p className="mb-6">
              {t(
                "Directional pairs trading (lead–lag strategy) turns market relationships into opportunity by using one asset’s move as an early signal for another.",
              )}
              {t(
                " When a clear leader–laggard dynamic exists, traders act quickly—taking a directional position in the lagging asset before it reacts.",
              )}
            </p>

            <p>
              {" "}
              {t(
                "By getting ahead of the move, this approach aims to capture early momentum as the lagging asset follows the leader.",
              )}
            </p>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
